"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var ContextTable = styled_components_1.default.table(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tborder-collapse: collapse;\n\twidth: 100%;\n"], ["\n\tborder-collapse: collapse;\n\twidth: 100%;\n"])));
var ContextPanel = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t", ";\n"], ["\n\t", ";\n"])), function (props) { return props.theme.contextPanel; });
var ContextMenu = /** @class */ (function (_super) {
    __extends(ContextMenu, _super);
    function ContextMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.onClick = function (evt) {
            if (_this.props.onClick) {
                _this.props.onClick(evt);
            }
            evt.stopPropagation();
        };
        _this.state = {
            open: true
        };
        return _this;
    }
    ContextMenu.prototype.render = function () {
        var count = react_1.default.Children.count(this.props.children);
        if (count === 0 || this.state.open === false) {
            return null;
        }
        return (react_1.default.createElement(ContextPanel, { onClick: this.onClick, "data-automationid": this.props.automationId },
            react_1.default.createElement(ContextTable, null,
                react_1.default.createElement("thead", null),
                react_1.default.createElement("tbody", null, this.props.children))));
    };
    ContextMenu.defaultProps = {
        onClick: function () { },
        automationId: 'test',
    };
    return ContextMenu;
}(react_1.Component));
exports.default = styled_components_1.withTheme(ContextMenu);
var templateObject_1, templateObject_2;
//# sourceMappingURL=ContextMenu.js.map